import { render, staticRenderFns } from "./schxxdzyxy.vue?vue&type=template&id=4bee0fa8&scoped=true&"
import script from "./schxxdzyxy.vue?vue&type=script&lang=js&"
export * from "./schxxdzyxy.vue?vue&type=script&lang=js&"
import style0 from "./schxxdzyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./schxxdzyxy.vue?vue&type=style&index=1&id=4bee0fa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee0fa8",
  null
  
)

export default component.exports